import React from 'react';

import FinanceSOA from '../components/finance/soa';

class FinanceSOAPage extends React.Component {

    render() {
        return (
            <FinanceSOA />
        )
    }
}


export default FinanceSOAPage;


// WEBPACK FOOTER //
// ./src/containers/finance-soa-page.js